/**
 * Re-exports the composed MUI `theme.components` factory from `./muiComponents`.
 * Implementation and per-component overrides live under `themes/muiComponents/`.
 *
 *
 */
export { default } from './muiComponents';
